import { median, roundHalfUp } from './math.js';
export const EVENT_LABELS = {
    vomit: '구토', diarrhea: '설사', seizure: '발작', collapse: '쓰러짐', appetiteLoss: '식욕 저하', lethargy: '기운 없음',
    bleeding: '출혈', disorientation: '방향 감각 저하', other: '직접 본 사실', cough: '기침', coughNight: '야간 기침',
    laboredBreathing: '힘들어 보인 호흡', exerciseIntolerance: '활동 중 멈춘 일', limping: '절뚝거림', riseDifficulty: '일어나기 힘들어함',
    stairAvoidance: '계단 피함', walkStopped: '산책 중 멈춤', reverseSneeze: '역재채기', honkingCough: '거위 울음 같은 기침',
    respiratoryDistress: '호흡이 힘들어 보인 순간', hairball: '헤어볼', litterBoxAvoid: '화장실 피함', overGrooming: '과도한 그루밍',
};
export const EVENT_LIMB_LABELS = {
    frontLeft: '앞 왼쪽', frontRight: '앞 오른쪽', hindLeft: '뒤 왼쪽', hindRight: '뒤 오른쪽',
    rearLeft: '뒤 왼쪽', rearRight: '뒤 오른쪽', unknown: '다리 모름',
};
/** 원본 종류·다리·보호자 메모를 함께 보여 주되 저장된 사실은 바꾸지 않는다. */
export function eventObservationDetail(event) {
    if (event.type === 'seizure' && event.payload?.type === 'seizure')
        return `발작 ${event.payload.durationSec ?? '미확인'}초${event.payload.recoverySec != null ? ` · 회복 ${event.payload.recoverySec}초` : ''}${event.severityNote ? ` · ${event.severityNote}` : ''}`;
    const limb = event.payload && 'limb' in event.payload ? EVENT_LIMB_LABELS[event.payload.limb] ?? '다리 모름' : null;
    const label = EVENT_LABELS[event.type] ?? '직접 본 사실';
    return [event.type === 'other' && event.severityNote?.trim() ? null : label, limb, event.severityNote?.trim()].filter(Boolean).join(' · ');
}
export function summarizeEvents(events, from, to) {
    const inWindow = events.filter((event) => event.occurredAt >= from && event.occurredAt <= to)
        .sort((a, b) => a.occurredAt - b.occurredAt || a.id.localeCompare(b.id));
    const byType = {};
    const byLimb = {};
    const durations = new Map();
    for (const event of inWindow) {
        byType[event.type] = (byType[event.type] ?? 0) + 1;
        if ((event.type === 'limping' || event.type === 'riseDifficulty') && event.payload && 'limb' in event.payload) {
            const limb = event.payload.limb;
            byLimb[limb] = (byLimb[limb] ?? 0) + 1;
        }
        if (event.durationSec != null) {
            const current = durations.get(event.type) ?? [];
            current.push(event.durationSec);
            durations.set(event.type, current);
        }
    }
    const durationStats = {};
    for (const [type, values] of durations) {
        const sorted = [...values].sort((a, b) => a - b);
        const middle = median(sorted);
        if (middle != null)
            durationStats[type] = { count: values.length, min: sorted[0], max: sorted[sorted.length - 1], median: roundHalfUp(middle, 1) };
    }
    return {
        events: inWindow,
        byType,
        byLimb,
        durationStats,
        firstOccurredAt: inWindow[0]?.occurredAt ?? null,
        lastOccurredAt: inWindow.at(-1)?.occurredAt ?? null,
    };
}
